import { useSelector } from 'react-redux';
import { selectUser } from '../../store/slices/authSlice';
import PageShell from '../../components/layout/PageShell';
import PageHeader from '../../components/layout/PageHeader';
import AdminStaffReferenceGuide from '../../components/admin/AdminStaffReferenceGuide';
import { resolveAdminStaffRole } from '../../constants/adminStaffReference';
import { Alert } from '@mui/material';

export default function AdminFunctionReferencePage() {
  const user = useSelector(selectUser);
  const role = resolveAdminStaffRole(user?.userType);

  return (
    <PageShell>
      <PageHeader
        gradient
        eyebrow="Admin & Staff"
        title="Full Function Reference"
        subtitle="Complete capability breakdown — roles, permissions, and hub tab actions."
      />
      {role ? (
        <AdminStaffReferenceGuide role={role} defaultExpanded />
      ) : (
        <Alert severity="info">This reference is available for Super Admin, Client Admin, and Employee accounts.</Alert>
      )}
    </PageShell>
  );
}
